// Constant definitions
var PACDORA_CONFIG = {
    MOBILE_BREAKPOINT: 980,
    MAX_RETRIES: 3,
    MESSAGE_DURATION: 2000,
    SLIDER_ANIMATION_DURATION: 1000
}

// State management
var Pacdora_isMobile = window.innerWidth < PACDORA_CONFIG.MOBILE_BREAKPOINT
var currentModelOrTemplate = null
var lastVariant = null

// Utility functions
var pacdoraUtils = {
    // Safe DOM query
    safeQuerySelector: function (selector, parent) {
        parent = parent || document
        try {
            return parent.querySelector(selector)
        } catch (error) {
            console.warn('Invalid selector: ' + selector, error)
            return null
        }
    },

    // Safe DOM query all
    safeQuerySelectorAll: function (selector, parent) {
        parent = parent || document
        try {
            return Array.from(parent.querySelectorAll(selector))
        } catch (error) {
            console.warn('Invalid selector: ' + selector, error)
            return []
        }
    },

    // Get event path
    getEventPath: function (event) {
        return (event.composedPath && event.composedPath()) || event.path || []
    },

    // Debounce function
    debounce: function (func, wait) {
        var timeout
        return function () {
            var args = arguments
            var context = this
            var later = function () {
                clearTimeout(timeout)
                func.apply(context, args)
            }
            clearTimeout(timeout)
            timeout = setTimeout(later, wait)
        }
    },

    // Safe JSON parsing
    safeJsonParse: function (str, defaultValue) {
        defaultValue = defaultValue || null
        try {
            return JSON.parse(str)
        } catch (error) {
            console.warn('JSON parse error:', error)
            return defaultValue
        }
    },
    // Handle bg_component string, supports comma-separated multiple components
    parseBgComponents: function (bgComponentStr, bgColor) {
        if (!bgComponentStr || !bgColor) {
            return {};
        }

        const result = {};
        const components = bgComponentStr.split(',').map(comp => comp.trim()).filter(comp => comp);

        components.forEach(component => {
            result[component] = {
                color: bgColor
            };
        });

        return result;
    },
}


var createPacdora3d = () => {
    const imgs = pacdoraUtils.safeQuerySelectorAll('img')
    const matchedElement = imgs.find((el) =>
        el.src.match(/.*\.pacdora\.3d.*/)
    )
    if (matchedElement) {
        window.addEventListener(
            'click',
            (e) => {
                if (e.isTrusted === false) return

                const path = pacdoraUtils.getEventPath(e)

                const pacdoraContainer = path.find(
                    (item) =>
                        item.className && typeof item.className === 'string' && (item.className.includes('pacdora-container') ||
                            item.className.includes('pacdora-box'))
                )
                const switchContainer = path.find((item) =>
                    item.className && typeof item.className === 'string' && item.className.includes('pacdora-switch-item')
                )
                if (switchContainer) {
                    const switchItem = e.target
                    console.log(switchItem)
                    let type = switchItem.dataset.type
                    // If the type cannot be found, look up the DOM to find data-type.
                    if (!type) {
                        let parentElement = switchItem.parentElement
                        while (parentElement && !type) {
                            type = parentElement.dataset.type
                            // If an element of class 'pacdora-switch-item' is found, stop searching.
                            if (
                                parentElement.className &&
                                typeof parentElement.className === 'string' &&
                                parentElement.className.includes('pacdora-switch-item')
                            ) {
                                break
                            }
                            parentElement = parentElement.parentElement
                        }
                    }
                    onSwitch2DAnd3D(type)
                }
            },
            true
        )
        window.addEventListener(
            'mousedown',
            (e) => {
                const path = pacdoraUtils.getEventPath(e)
                const pacdoraContainer = path.find((item) =>
                    item.className && typeof item.className === 'string' && item.className.includes('pacdora-box-info')
                )
                if (pacdoraContainer) {
                    e.stopPropagation()
                }
            },
            true
        )
        const div = document.createElement('div')
        Object.assign(div.style, { width: '100%', height: '100%' })
        div.className = 'pacdora-box-info'
        const loadingDiv = document.createElement('div')
        loadingDiv.className = 'pacdora-box-loading'
        div.appendChild(loadingDiv)
        const D3ContainerDiv = document.createElement('div')
        D3ContainerDiv.className = 'pacdora-box-info-slider'
        const firstDiv = document.createElement('div')
        firstDiv.className = 'pacdora-box-info-item'

        // Create the switch element
        const switchDiv = document.createElement('div')
        switchDiv.className = 'pacdora-d3-and-d2-switch'
        switchDiv.innerHTML = `
        <div class="pacdora-switch-item active" data-type="3d">3D</div>
        <div class="pacdora-switch-item" data-type="dieline">Dieline</div>
      `;

        // Use addEventListener to bind events
        const switchItems = switchDiv.querySelectorAll('.pacdora-switch-item')
        switchItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                const type = e.target.dataset.type
                onSwitch2DAnd3D(type, e)
            })
        })

        // Replace the original image
        matchedElement.parentNode?.insertBefore(div, matchedElement)
        matchedElement.style.display = 'none'
        // Create 3D container
        const d3Div = document.createElement('div')
        d3Div.className = 'd3'
        d3Div.dataset.pacdoraUi = '3d'
        d3Div.dataset.pacdoraId = 'd3'
        d3Div.dataset.showSlider = true
        // Add the control to the 3D container
        firstDiv.appendChild(d3Div)
        // Create the dieline container
        const dielineDiv = document.createElement('div')
        dielineDiv.className = 'dieline'
        dielineDiv.dataset.pacdoraUi = 'dieline'

        dielineDiv.dataset.notUseScience = true
        const secondDiv = document.createElement('div')
        secondDiv.className = 'pacdora-box-info-item'
        secondDiv.appendChild(dielineDiv)
        D3ContainerDiv.appendChild(firstDiv)
        D3ContainerDiv.appendChild(secondDiv)
        div.appendChild(D3ContainerDiv)
        div.appendChild(switchDiv)
    }
}
async function interceptCart() {
    // Modify the native fetch method to intercept API calls for adding to the shopping cart.
    if (!window.originalFetch && window.fetch) {
        window.originalFetch = window.fetch
        window.fetch = async function (url, options) {
            console.log(url, options)
            // Check if it is a request to add to the shopping cart.
            if (
                typeof url === 'string' &&
                url.includes('/cart/add') &&
                options &&
                options.body
            ) {
                let pacdoraObj = {
                    projectId: undefined,
                    image3D: '',
                }
                try {
                    if (window.Pacdora) {
                        await Pacdora._waitProjectCreate()
                        let { id, screenshot } = await Pacdora.getBoxInfo()
                        console.log('Pacdora project screenshot:', screenshot)
                        pacdoraObj.projectId = id
                        pacdoraObj.image3D = 'https:' + screenshot
                    }
                } catch (error) {
                    console.error(
                        'Error getting project ID in fetch interceptor:',
                        error
                    )
                }

                // If the request body is FormData, add the project ID
                if (options.body instanceof FormData) {
                    options.body.append(
                        'properties[pacdora-project-id]',
                        pacdoraObj.projectId
                    )
                    options.body.append(
                        'properties[pacdora-image3D]',
                        pacdoraObj.image3D
                    )
                    console.log('Added project ID to FormData')
                }
                // If the request body is a string (e.g. JSON or URL encoded), parse and add the project ID
                else if (typeof options.body === 'string') {
                    try {
                        // Try to parse as JSON
                        const bodyObj = JSON.parse(options.body)
                        if (!bodyObj.properties) bodyObj.properties = {}
                        bodyObj.properties['pacdora-project-id'] = pacdoraObj.projectId
                        bodyObj.properties['pacdora-image3D'] = pacdoraObj.image3D
                        options.body = JSON.stringify(bodyObj)
                        console.log('Added project ID to JSON body')
                    } catch (e) {
                        // Not JSON, possibly URL encoded form data
                        try {
                            const bodyParams = new URLSearchParams(options.body)
                            bodyParams.append(
                                'properties[pacdora-project-id]',
                                pacdoraObj.projectId
                            )
                            bodyParams.append(
                                'properties[pacdora-image3D]',
                                pacdoraObj.image3D
                            )
                            options.body = bodyParams.toString()
                            console.log('Added project ID to URL encoded body')
                        } catch (urlError) {
                            console.error('Failed to parse URL encoded body:', urlError)
                        }
                    }
                }
            }

            // Continue the original fetch call
            return window.originalFetch.apply(this, arguments)
        }
        console.log('Fetch method intercepted')
    }
}

// Get the currently selected variant
function getSelectedVariant() {
    let form_selector = window.PRODUCT_DATA.form_selector
    if (!form_selector) {
        console.warn('No form_selector set')
        return null
    }

    const form = pacdoraUtils.safeQuerySelector(form_selector)
    if (!form) {
        console.warn('Form element not found:', form_selector)
        return null
    }

    // Get all option selector values
    const selects = pacdoraUtils.safeQuerySelectorAll('select', form)
    if (selects.length === 0) {
        console.warn('No selector elements found in form')
        return null
    }

    const selectedOptions = []
    console.log('selects', selects)
    selects.forEach((select) => {
        // Get the selected option element
        const selectedOption = select.options[select.selectedIndex]
        // Get the data-option-value-id attribute from the selected option
        selectedOptions.push(selectedOption.value)
    })

    console.log('Selected options:', selectedOptions)

    // Find variant matching all selected options
    const variant = window.PRODUCT_DATA.variants.find((v) => {
        const variantOptions = v.options.map((opt) => opt.name)
        console.log('Variant options:', variantOptions)
        return (
            selectedOptions.length === variantOptions.length &&
            selectedOptions.every((option, index) => option == variantOptions[index])
        )
    })

    console.log('Matching variant found:', variant)
    return variant
}

// Listen for product option changes
function listenToFormSelectors() {
    const form_selector = window.PRODUCT_DATA.form_selector
    if (!form_selector) {
        console.warn('No form_selector set')
        return
    }

    console.log('Setting up document-level option change listener')

    document.addEventListener('change', function (e) {
        const path = pacdoraUtils.getEventPath(e)
        if (!path || path.length === 0) {
            console.warn('Unable to get event path')
            return
        }

        // Check if the event target is a selector
        if (e.target.tagName === 'SELECT') {
            let isInTargetForm = false
            for (let i = 0; i < path.length; i++) {
                const element = path[i]
                if (
                    element.nodeType === 1 &&
                    element.matches &&
                    element.matches(form_selector)
                ) {
                    isInTargetForm = true
                    break
                }
            }

            if (isInTargetForm) {
                console.log('Selector in target form changed')
                const updatedVariant = getSelectedVariant()
                if (!updatedVariant) {
                    console.warn('No matching variant found')
                    return
                }
                if (lastVariant?.metafields && updatedVariant?.metafields) {
                    const lastKeys = Object.keys(lastVariant.metafields)
                    const updatedKeys = Object.keys(updatedVariant.metafields)
                    if (
                        lastKeys.length === updatedKeys.length &&
                        lastKeys.every(
                            (key) =>
                                updatedVariant.metafields.hasOwnProperty(key) &&
                                lastVariant.metafields[key] === updatedVariant.metafields[key]
                        )
                    ) {
                        return
                    }
                }
                console.log('Variant updated to:', updatedVariant.id)
                updatePacdoraWithVariant(updatedVariant)
            }
        }
    })

    console.log('Document-level option change listener added')
}

// Update Pacdora based on selected variant
async function updatePacdoraWithVariant(variant) {
    console.log('Updating Pacdora with new variant:', variant)

    // If Pacdora is initialized, update settings
    if (window.Pacdora) {
        try {
            // Update material (if available)
            let useType = ''
            if (variant.metafields.modelId) {
                useType = 'model'
            } else if (variant.metafields.templateId) {
                useType = 'template'
            }
            if (
                useType &&
                currentModelOrTemplate !== variant.metafields.modelId &&
                currentModelOrTemplate !== variant.metafields.templateId
            ) {
                const loadingDiv = pacdoraUtils.safeQuerySelector('.pacdora-box-loading')
                if (loadingDiv) {
                    loadingDiv.style.display = 'block'
                }
                const productData = {
                    modelId: variant.metafields.modelId ?? '',
                    templateId: variant.metafields.templateId ?? '',
                    bg: variant.metafields.bg ?? '',
                    bg_component: variant.metafields.bg_component ?? ''
                }
                await createPacdoraScene(useType, variant, productData)
                if (loadingDiv) {
                    loadingDiv.style.display = 'none'
                }
                return
            }
            let updateFlag = false
            if (
                variant.metafields.material &&
                variant.metafields.material.trim() !== ''
            ) {
                await Pacdora.setMaterial({
                    name: variant.name,
                    image: variant.metafields.material,
                    async: false
                })
                updateFlag = true
            }

            // Update size (if available)
            let size = variant.metafields.size
            if (size) {
                // Handle 'x' and '*' cases
                const dimensions = size
                    .toLowerCase()
                    .replace(/[x*]/g, '*')
                    .split('*')
                    .map((str) => str.trim())
                    .map(Number)
                    .filter((num) => !isNaN(num))

                if (dimensions.length === 3) {
                    const [length, width, height] = dimensions
                    console.log('Dimensions:', { length, width, height })
                    await Pacdora.setSize({
                        length,
                        width,
                        height,
                        async: false
                    })
                }
                updateFlag = true
            }

            // Apply updates
            if (updateFlag) {
                await Pacdora.update()
                console.log('Pacdora updated with new variant')
            }
            console.log(lastVariant, variant);
            if (lastVariant.metafields.bg !== variant.metafields.bg || lastVariant.metafields.bg_component !== variant.metafields.bg_component) {
                const bgComponentList = pacdoraUtils.parseBgComponents(variant.metafields.bg_component, variant.metafields.bg);
                if (Object.keys(bgComponentList).length > 0) {
                    await Pacdora.setCustomMaterial(
                        bgComponentList,
                        {
                            enablePartNameMatching: true
                        }
                    )
                }
            }
            lastVariant = variant;
        } catch (error) {
            console.error('Error updating Pacdora:', error)
        }
    } else if (window.Pacdora) {
        // If using Pacdora, do similar updates
        try {
            // Similar Pacdora update logic
            console.log('Pacdora update logic needs to be implemented')
        } catch (error) {
            console.error('Error updating Pacdora:', error)
        }
    }
}

var MAX_RETRIES = 3

async function loadPacdoraScriptWithRetry(retries = 0) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://api.pacdora.com/sdk/Pacdora.js?app_id=${window.PACDORA_CONFIG.appId}`
        script.async = true
        script.onload = () => {
            if (window.Pacdora) {
                resolve()
            } else {
                if (retries < MAX_RETRIES) {
                    // Retry on failure
                    loadPacdoraScriptWithRetry(retries + 1)
                        .then(resolve)
                        .catch(reject)
                } else {
                    reject(new Error('Pacdora script load failed, exceeded maximum retry count'))
                }
            }
        }
        script.onerror = () => {
            if (retries < MAX_RETRIES) {
                loadPacdoraScriptWithRetry(retries + 1)
                    .then(resolve)
                    .catch(reject)
            } else {
                reject(new Error('Pacdora script load failed, exceeded maximum retry count'))
            }
        }
        document.body.appendChild(script)
    })
}
var createPacdora = async () => {
    interceptCart()
    const selectedVariant = window.PRODUCT_DATA.current_variant_id
    const variantData = window.PRODUCT_DATA.variants.find(
        (v) => v.id == selectedVariant
    )
    lastVariant = variantData
    const modelId = variantData.metafields.modelId
        ? variantData.metafields.modelId
        : window.PRODUCT_DATA.pacdora_model_id
    const templateId = variantData.metafields.templateId
        ? variantData.metafields.templateId
        : window.PRODUCT_DATA.pacdora_template_id
    if (!modelId && !templateId) {
        showMessage('No model or template id found')
        return
    }
    const bg = window.PRODUCT_DATA.pacdora_bg;
    const bg_component = window.PRODUCT_DATA.pacdora_bg_component;
    let useType = 'model'
    if (variantData.metafields.modelId) {
        useType = 'model'
    } else if (variantData.metafields.templateId) {
        useType = 'template'
    } else if (window.PRODUCT_DATA.pacdora_model_id) {
        useType = 'model'
    } else if (window.PRODUCT_DATA.pacdora_template_id) {
        useType = 'template'
    }
    const appId = window.PACDORA_CONFIG.appId
    if (!appId) {
        showMessage('No app id found')
        return
    }
    createPacdora3d()
    await loadPacdoraScriptWithRetry()
    if (window.Pacdora) {
        Pacdora = window.Pacdora
        if (typeof Pacdora !== 'undefined') {
            console.log('Pacdora and Pacdora initialized')

            await Pacdora.init({
                appId: appId,
                isDelay: true,
                quotation: window.PACDORA_CONFIG.quotationOpen,
                customDefault: false,
               theme: '#333333',
  priceAmountUnit: 0
            })
            await createPacdoraScene(useType, variantData, { modelId, templateId, bg, bg_component });

            Pacdora.$on('3d:init', () => {
                console.log('init-complete')
                const loadingDivs = pacdoraUtils.safeQuerySelectorAll('.pacdora-box-loading')
                loadingDivs.forEach((item) => {
                    item.style.display = 'none'
                })
                const skeletonSelects = pacdoraUtils.safeQuerySelector(
                    '.pacdora-skeleton-selects'
                )
                const selectorContent = pacdoraUtils.safeQuerySelector(
                    '.pacdora-selector-content'
                )
                if (skeletonSelects) {
                    skeletonSelects.style.display = 'none'
                }
                if (selectorContent) {
                    selectorContent.style.display = 'block'
                }
                const selectContent = document.querySelector(
                    '.pacdora-selector-content'
                )
                if (selectContent) {
                    selectContent.style.minHeight = '0px'
                }
                const selectorBox = document.querySelector('.pacdora-selector-box')
                if (selectorBox) {
                    selectorBox.style.opacity = '1'
                    selectorBox.style.height = 'fit-content'
                }
            })
            const loadingBtnDiv = pacdoraUtils.safeQuerySelectorAll('.pac-loading')
            if (loadingBtnDiv) {
                loadingBtnDiv.forEach((item) => {
                    item.style.display = 'none'
                })
            }
            const contactButton = pacdoraUtils.safeQuerySelector('#pacdora-contact-button')
            if (contactButton) {
                contactButton.addEventListener('click', async () => {
                    Pacdora.openPlusContactDialog({
                        visible: true,
                        canCancel: true,
                        confirm: (result) => {
                            console.log('confirm ===>', result)
                        },
                    })
                })
                contactButton.style.backgroundColor = '#000'
                contactButton.style.color = '#fff'
                contactButton.style.cursor = 'pointer'
            }
            Pacdora.$on('contact-dialog:loading', () => {
                const loadingEle = contactButton.querySelector('.pac-loading')
                if (loadingEle) {
                    loadingEle.style.display = 'block'
                }
            })
            Pacdora.$on('contact-dialog:complete', () => {
                const loadingEle = contactButton.querySelector('.pac-loading')
                if (loadingEle) {
                    loadingEle.style.display = 'none'
                }
            })
            const buyButton = pacdoraUtils.safeQuerySelector('#pacdora-buy-button')
            if (buyButton) {
                buyButton.addEventListener('click', async () => {
                    await createShopifyOrder()
                })
                buyButton.style.backgroundColor = '#000'
                buyButton.style.color = '#fff'
                buyButton.style.cursor = 'pointer'
            }
            const designButton = pacdoraUtils.safeQuerySelector('#pacdora-advanced-design')
            mobileBtnEventHijacking(designButton)
            if (designButton) {
                designButton.addEventListener('click', () => {
                    const loadingEle = designButton.querySelector('.pac-loading')
                    if (loadingEle) {
                        loadingEle.style.display = 'block'
                    }
                })
            }
            Pacdora.$on('download:start', () => {
                const downloadEle = pacdoraUtils.safeQuerySelector('#pacdora-download')
                if (downloadEle) {
                    downloadEle.style.cursor = 'not-allowed'
                    const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
                    const textEle = downloadEle.querySelector('.pac-text')
                    if (textEle) {
                        textEle.innerText = 'Downloading...'
                    }
                    if (downloadLoadingEle) {
                        downloadLoadingEle.style.display = 'block'
                    }
                }
            })
            Pacdora.$on('download:success', () => {
                const downloadEle = pacdoraUtils.safeQuerySelector('#pacdora-download')
                if (downloadEle) {
                    downloadEle.style.cursor = 'pointer'
                    const textEle = downloadEle.querySelector('.pac-text')
                    if (textEle) {
                        textEle.innerText = 'Download success'
                        setTimeout(() => {
                            textEle.innerText = 'Download Dieline'
                        }, 1000)
                    }
                    const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
                    if (downloadLoadingEle) {
                        downloadLoadingEle.style.display = 'none'
                    }
                }
            })
            Pacdora.$on('download:fail', () => {
                const downloadEle = pacdoraUtils.safeQuerySelector('#pacdora-download')
                if (downloadEle) {
                    downloadEle.innerText = 'Download failed'
                    setTimeout(() => {
                        downloadEle.innerText = 'Download Dieline'
                    }, 1000)
                    const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
                    if (downloadLoadingEle) {
                        downloadLoadingEle.style.display = 'none'
                    }
                }
            })
            Pacdora.$on('design:opened', () => {
                const loadingEle = pacdoraUtils.safeQuerySelector(
                    '#pacdora-advanced-design .pac-loading'
                )
                if (loadingEle) {
                    loadingEle.style.display = 'none'
                }
                const shopifyFixed = pacdoraUtils.safeQuerySelector('#PBarNextFrameWrapper')
                if (shopifyFixed) {
                    shopifyFixed.style.display = 'none'
                }
                document.body.style.overflow = 'hidden'
                document.body.style.position = 'fixed'
                document.body.style.width = '100%'
                document.body.style.top = `-${window.scrollY}px`
            })
            Pacdora.$on('advancedDesign:closed', () => {
                // Restore body scroll
                document.body.style.overflow = ''
                document.body.style.position = ''
            })
            Pacdora.$on('design:save', async (data) => {
                if (data.type === 'buyNow') {
                    await createShopifyOrder()
                    return false
                }
            })
        }
    }
}
async function createShopifyOrder() {
    const buyLoading = pacdoraUtils.safeQuerySelector('#pacdora-buy-button .pac-loading')
    if (buyLoading) {
        buyLoading.style.display = 'block'
    }
    await Pacdora._waitProjectCreate()
    await Pacdora.priceReady()
    let unitPrice = 0
    let quantity = 1
    const variantAttributes = []
    const data = Pacdora.getAdvancedData()
    const quantityData = Pacdora.getQuantityData()
    if (data) {
        data.forEach((item) => {
            variantAttributes.push({
                key: item.type,
                value: item.selectedName
            })
        })
    }
    if (quantityData) {
        unitPrice =
            quantityData.options.find(
                (item) => item.quantity === quantityData.quantity
            )?.unit_price ||
            quantityData.price / quantityData.quantity ||
            0
        quantity = quantityData.quantity || 1
    }
    const { screenshot, id } = await Pacdora.getBoxInfo()
    variantAttributes.push({
        key: 'image3D',
        value: 'https:' + screenshot
    })
    variantAttributes.push({
        key: 'projectId',
        value: id.toString()
    })
    const postData = {
        variantId: window.PRODUCT_DATA.current_variant_id.toString(),
        unitPrice: unitPrice,
        quantity: quantity,
        variantAttributes: variantAttributes
    }
    try {
        let response = await fetch(
            'https://api.pacdora.com/open/v1/shopify/order',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('api-token'),
                },
                body: JSON.stringify(postData)
            }
        )
        let res = await response.json()
        if (res.code === 200) {
            window.location.href = res.data.url
        } else {
            showMessage('Create order failed')
        }
    } catch (err) {
        console.error('createShopifyOrder error:', err)
        showMessage('Create order failed')
    } finally {
        if (buyLoading) {
            buyLoading.style.display = 'none'
        }
    }
}
async function initPacdora() {
    document.addEventListener('DOMContentLoaded', async () => {
        await createPacdora()
        // Add a listener for changes to the form selector
        listenToFormSelectors()
    })
}
function onSwitch2DAnd3D(type, event) {
    event?.stopPropagation()
    event?.preventDefault()
    const switchItems = pacdoraUtils.safeQuerySelectorAll('.pacdora-switch-item')
    const boxInfo = pacdoraUtils.safeQuerySelector('.pacdora-box-info-slider')
    if (type === '3d') {
        switchItems[0].className = 'pacdora-switch-item active'
        switchItems[1].className = 'pacdora-switch-item'
        boxInfo.style.transform = 'translateX(0)'
    } else if (type === 'dieline') {
        switchItems[0].className = 'pacdora-switch-item'
        switchItems[1].className = 'pacdora-switch-item active'
        boxInfo.style.transform = 'translateX(-100%)'
    }
}


function showMessage(message, type) {
    Pac_Shopify_Message.message({
        type: type,
        message
    })
}
if (!window.pacdoraSectionLoadHandler) {
    window.pacdoraSectionLoadHandler = async (event) => {
        await createPacdora()
    }
}

document.removeEventListener(
    'shopify:section:load',
    window.pacdoraSectionLoadHandler
)
document.addEventListener(
    'shopify:section:load',
    window.pacdoraSectionLoadHandler
)
async function createPacdoraScene(useType, variantData, productData) {
    console.log('createPacdoraScene', useType, variantData, productData);
    const { modelId, templateId, bg, bg_component } = productData;
    const dimension = {
        width: undefined,
        height: undefined,
        length: undefined,
    }
    const materialSetting = {
        materialName: undefined,
        materialImage: undefined
    }
    if (variantData.metafields.material) {
        materialSetting.materialId = 44
        materialSetting.materialName = variantData.name
        materialSetting.materialImage = variantData.metafields.material
    }
    let size = variantData.metafields.size
    if (size) {
        const dimensions = size
            .toLowerCase() // Convert to lowercase
            .replace(/[x*]/g, '*') // Replace all x and * with *
            .split('*')
            .map((str) => str.trim())
            .map(Number)
            .filter((num) => !isNaN(num))

        if (dimensions.length === 3) {
            const [length, width, height] = dimensions
            dimension.length = length
            dimension.width = width
            dimension.height = height
        }
    }
    if (!useType || !variantData) {
        console.warn('Missing parameters for creating scene')
        return null
    }

    const packagingColors = ['#ff0000', '#00ff00', '#0000ff', '#893829']

    let sceneParams = {
        doneBtn: 'Save',
        packagingColors

    }
    if (!window.PACDORA_CONFIG.quotationOpen) {
        sceneParams.advancedSetting = {
            ...materialSetting,
            width: dimension.width,
            height: dimension.height,
            length: dimension.length
        }
    }
    if (useType === 'model' && variantData.metafields.modelId) {
        sceneParams.modelId = variantData.metafields.modelId
    } else if (useType === 'template' && variantData.metafields.templateId) {
        sceneParams.templateId = variantData.metafields.templateId
    } else if (useType === 'model' && modelId) {
        sceneParams.modelId = modelId
    } else if (useType === 'template' && templateId) {
        sceneParams.templateId = templateId
    } else {
        console.warn('Invalid useType or missing ID')
        return null
    }
    try {
        currentModelOrTemplate = sceneParams.modelId || sceneParams.templateId;
        let bgComponentList = {};

        // First handle bg_component in productData
        if (bg && bg_component) {
            const productBgComponents = pacdoraUtils.parseBgComponents(bg_component, bg);
            bgComponentList = { ...bgComponentList, ...productBgComponents };
        }

        // Then handle bg_component in variantData (higher priority, will override settings for components with the same name)
        if (variantData.metafields.bg && variantData.metafields.bg_component) {
            const variantBgComponents = pacdoraUtils.parseBgComponents(variantData.metafields.bg_component, variantData.metafields.bg);
            bgComponentList = { ...bgComponentList, ...variantBgComponents };
        }
        console.log('bgComponentList', bgComponentList);
        if (Object.keys(bgComponentList).length > 0) {
            sceneParams.customMaterial = {
                option: bgComponentList,
                config: {
                    enablePartNameMatching: true
                }
            };
        }
        const id = await Pacdora.createScene(sceneParams);
        return id

    } catch (err) {
        console.error('Error creating scene:', err)
        const loadingDiv = pacdoraUtils.safeQuerySelector('.pacdora-box-loading')
        if (loadingDiv) {
            loadingDiv.style.display = 'none'
        }
        return null
    }
}
function mobileBtnEventHijacking(dom) {
    if (Pacdora_isMobile) {
        dom.addEventListener(
            'click',
            (e) => {
                showMessage('Please Use Desktop for the Best Experience.', 'warn')
                e.stopPropagation()
                e.preventDefault()
            },
            {
                capture: true
            }
        )
    }
}
class Pac_Shopify_Message {
    static message({ type, message }) {
        let messageBox = pacdoraUtils.safeQuerySelector('.message-box')
        if (!messageBox) {
            messageBox = document.createElement('div')
            messageBox.className = 'message-box'
            Object.assign(messageBox.style, {
                position: 'fixed',
                top: '32px',
                left: 0,
                right: 0,
                margin: 'auto',
                zIndex: 1999000000,
                textAlign: 'center'
            })
            document.body.appendChild(messageBox)
        }
        const div = document.createElement('div')
        div.style.marginBottom = '24px'
        const messageItem = document.createElement('div')
        div.appendChild(messageItem)
        Object.assign(messageItem.style, {
            height: '48px',
            background: '#ffffff',
            borderRadius: '24px',
            boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.12)',
            display: 'inline-block',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '48px',
            padding: '0 20px',
            animation: 'message-in 0.5s'
        })
        let img = ``
        if (type === 'success') {
            img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/success.png"/>`
        } else if (type === 'warn') {
            img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/warn.png"/>`
        } else if (type === 'error') {
            img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/error.png"/>`
        }
        messageItem.innerHTML = `
        ${img}
        ${message}
    `
        messageBox.appendChild(div)
        setTimeout(() => {
            messageBox?.removeChild(div)
        }, 2000)
    }
    static success(message) {
        this.message({ type: 'success', message })
    }
    static warn(message) {
        this.message({ type: 'warn', message })
    }
    static error(message) {
        this.message({ type: 'error', message })
    }
}
